const actions = {
  fetchFeatures: 'FETCH::FEATURES',
  setFeatures: 'SET::FEATURES'
}

export const getFeatures = state => state

export default actions



// WEBPACK FOOTER //
// ./src/store/features/actions.js